import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { getData, postData } from "../../../../Services/Fetchnodeservices";

// ===================== ICONS =====================
const SearchIcon = () => (
  <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
    <circle cx="11" cy="11" r="8" />
    <line x1="21" y1="21" x2="16.65" y2="16.65" />
  </svg>
);

const FilterIcon = () => (
  <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8">
    <polygon points="22 3 2 3 10 13 10 21 14 18 14 13 22 3" />
  </svg>
);

const ChevronLeftIcon = () => (
  <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5">
    <polyline points="15 18 9 12 15 6" />
  </svg>
);

const ChevronRightIcon = () => (
  <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5">
    <polyline points="9 18 15 12 9 6" />
  </svg>
);

const CheckIcon = () => (
  <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5">
    <polyline points="20 6 9 17 4 12" />
  </svg>
);

const XIcon = () => (
  <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5">
    <line x1="18" y1="6" x2="6" y2="18" />
    <line x1="6" y1="6" x2="18" y2="18" />
  </svg>
);

const EyeIcon = () => (
  <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8">
    <path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z" />
    <circle cx="12" cy="12" r="3" />
  </svg>
);

const SpinnerIcon = () => (
  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
    <path d="M12 2v4M12 18v4M4.93 4.93l2.83 2.83M16.24 16.24l2.83 2.83M2 12h4M18 12h4M4.93 19.07l2.83-2.83M16.24 7.76l2.83-2.83" 
      style={{ animation: "spin 0.8s linear infinite", transformOrigin: "center" }} />
  </svg>
);

const BackIcon = () => (
  <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
    <polyline points="15 18 9 12 15 6" />
  </svg>
);

const SparklesIcon = () => (
  <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5">
    <path d="M12 3L14 8L19 10L14 12L12 17L10 12L5 10L10 8L12 3Z"/>
    <path d="M19 4L20 7L23 8L20 9L19 12L18 9L15 8L18 7L19 4Z"/>
  </svg>
);

const TrendingIcon = () => (
  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8">
    <path d="M23 6l-9.5 9.5-5-5L1 18"/>
    <path d="M17 6h6v6"/>
  </svg>
);

const TagIcon = () => (
  <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5">
    <path d="M20.59 13.41l-7.17 7.17a2 2 0 0 1-2.83 0L2 12V2h10l8.59 8.59a2 2 0 0 1 0 2.82z"/>
    <line x1="7" y1="7" x2="7.01" y2="7"/>
  </svg>
);

const WalletIcon = () => (
  <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5">
    <path d="M22 6v12a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2h16a2 2 0 0 1 2 2z"/>
    <path d="M22 10h-4a2 2 0 0 0-2 2v0a2 2 0 0 0 2 2h4"/>
    <circle cx="18" cy="14" r="1" fill="currentColor"/>
  </svg>
);

const RefreshIcon = () => (
  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8">
    <path d="M23 4v6h-6"/>
    <path d="M1 20v-6h6"/>
    <path d="M3.51 9a9 9 0 0 1 14.85-3.36L23 10"/>
    <path d="M20.49 15a9 9 0 0 1-14.85 3.36L1 14"/>
  </svg>
);

const RestaurantIcon = () => (
  <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5">
    <path d="M3 3h7v7H3z"/>
    <path d="M14 3h7v7h-7z"/>
    <path d="M14 14h7v7h-7z"/>
    <path d="M3 14h7v7H3z"/>
  </svg>
);

const RiderIcon = () => (
  <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5">
    <circle cx="5" cy="18" r="3"/>
    <circle cx="19" cy="18" r="3"/>
    <polyline points="12 19 12 15 9 9 17 9"/>
  </svg>
);

// ===================== THEME =====================
const getThemeStyles = (isDark) => ({
  bgPrimary: isDark ? '#111827' : '#F9FAFB',
  bgSecondary: isDark ? '#1F2937' : '#FFFFFF',
  bgTertiary: isDark ? '#374151' : '#F3F4F6',
  textPrimary: isDark ? '#F9FAFB' : '#111827',
  textSecondary: isDark ? '#9CA3AF' : '#6B7280',
  textMuted: isDark ? '#6B7280' : '#9CA3AF',
  border: isDark ? '#374151' : '#E5E7EB',
  borderLight: isDark ? '#4B5563' : '#F3F4F6',
  cardBg: isDark ? '#1F2937' : '#FFFFFF',
  inputBg: isDark ? '#374151' : '#F9FAFB',
  hoverBg: isDark ? '#374151' : '#F9FAFB',
  success: '#10B981',
  warning: '#F59E0B',
  danger: '#EF4444',
  info: '#3B82F6',
  purple: '#8B5CF6'
});

// ===================== STATUS BADGE =====================
const StatusBadge = ({ status, isDark }) => {
  const getStatusConfig = (adminStatus) => {
    const statusMap = {
      approved: { bg: 'rgba(16,185,129,0.12)', color: '#10b981', label: 'Approved' },
      pending: { bg: 'rgba(245,158,11,0.12)', color: '#f59e0b', label: 'Pending' },
      rejected: { bg: 'rgba(239,68,68,0.12)', color: '#ef4444', label: 'Rejected' },
      processing: { bg: 'rgba(59,130,246,0.12)', color: '#3b82f6', label: 'Processing' },
    };
    return statusMap[adminStatus?.toLowerCase()] || statusMap.pending;
  };
  
  const c = getStatusConfig(status);
  
  return (
    <span style={{ 
      display: 'inline-flex', 
      alignItems: 'center', 
      gap: '6px', 
      padding: '4px 12px', 
      borderRadius: '20px', 
      fontSize: '11px', 
      fontWeight: '600', 
      background: c.bg, 
      color: c.color 
    }}>
      <span style={{ width: '6px', height: '6px', borderRadius: '50%', background: c.color }} />
      {c.label}
    </span>
  );
};

// ===================== ACTION BUTTONS =====================
const ActionButtons = ({ row, onApprove, onReject, onView, isDark }) => {
  const styles = getThemeStyles(isDark);
  
  return (
    <div style={{ display: 'flex', gap: '8px', justifyContent: 'center' }}>
      {row.admin_status?.toLowerCase() === 'pending' && (
        <>
          <button
            onClick={() => onApprove(row)}
            style={{
              padding: '6px 12px',
              borderRadius: '8px',
              border: 'none',
              background: 'rgba(16,185,129,0.15)',
              color: styles.success,
              cursor: 'pointer',
              fontSize: '11px',
              fontWeight: 500,
              display: 'inline-flex',
              alignItems: 'center',
              gap: '6px',
              transition: 'all 0.2s ease'
            }}
            onMouseEnter={(e) => e.currentTarget.style.background = 'rgba(16,185,129,0.25)'}
            onMouseLeave={(e) => e.currentTarget.style.background = 'rgba(16,185,129,0.15)'}
          >
            <CheckIcon /> Approve
          </button>
          <button
            onClick={() => onReject(row)}
            style={{
              padding: '6px 12px',
              borderRadius: '8px',
              border: 'none',
              background: 'rgba(239,68,68,0.15)',
              color: styles.danger,
              cursor: 'pointer',
              fontSize: '11px',
              fontWeight: 500,
              display: 'inline-flex',
              alignItems: 'center',
              gap: '6px',
              transition: 'all 0.2s ease'
            }}
            onMouseEnter={(e) => e.currentTarget.style.background = 'rgba(239,68,68,0.25)'}
            onMouseLeave={(e) => e.currentTarget.style.background = 'rgba(239,68,68,0.15)'}
          >
            <XIcon /> Reject
          </button>
        </>
      )}
      <button
        onClick={() => onView(row)}
        style={{
          padding: '6px 12px',
          borderRadius: '8px',
          border: `1px solid ${styles.border}`,
          background: 'transparent',
          color: styles.textSecondary,
          cursor: 'pointer',
          fontSize: '11px',
          display: 'inline-flex',
          alignItems: 'center',
          gap: '6px',
          transition: 'all 0.2s ease'
        }}
        onMouseEnter={(e) => e.currentTarget.style.background = styles.hoverBg}
        onMouseLeave={(e) => e.currentTarget.style.background = 'transparent'}
      >
        <EyeIcon /> View
      </button>
    </div>
  );
};

// ===================== STAT CARD =====================
const StatCard = ({ icon, title, value, subtitle, color, isDark }) => {
  const styles = getThemeStyles(isDark);
  
  return (
    <div style={{
      background: styles.cardBg,
      borderRadius: '20px',
      padding: '20px',
      border: `1px solid ${styles.border}`,
      transition: 'transform 0.2s ease, box-shadow 0.2s ease'
    }}
    onMouseEnter={(e) => {
      e.currentTarget.style.transform = 'translateY(-2px)';
      e.currentTarget.style.boxShadow = '0 8px 25px rgba(0,0,0,0.1)';
    }}
    onMouseLeave={(e) => {
      e.currentTarget.style.transform = 'translateY(0)';
      e.currentTarget.style.boxShadow = 'none';
    }}>
      <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: '16px' }}>
        <div style={{
          width: '48px',
          height: '48px',
          background: `linear-gradient(135deg, ${color}20, ${color}10)`,
          borderRadius: '16px',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          color: color
        }}>
          {icon}
        </div>
        {subtitle && (
          <span style={{
            fontSize: '11px',
            color: styles.textMuted,
            background: styles.bgTertiary,
            padding: '4px 10px',
            borderRadius: '20px'
          }}>
            {subtitle}
          </span>
        )}
      </div>
      <div>
        <p style={{ fontSize: '12px', color: styles.textSecondary, marginBottom: '8px' }}>{title}</p>
        <p style={{ fontSize: '28px', fontWeight: '700', color: styles.textPrimary, margin: 0 }}>{value}</p>
      </div>
    </div>
  );
};

// ===================== WITHDRAWALS TABLE =====================
const WithdrawalsTable = ({ withdrawals, loading, onApprove, onReject, onView, isDark }) => {
  const styles = getThemeStyles(isDark);
  const [searchTerm, setSearchTerm] = useState('');
  const [statusFilter, setStatusFilter] = useState('all');
  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 10;

  const filteredWithdrawals = withdrawals.filter(w => {
    const name = w.restaurant_name || w.rider_name || '';
    const matchesSearch = name.toLowerCase().includes(searchTerm.toLowerCase()) ||
                          w.id?.toString().includes(searchTerm) ||
                          w.resturant_id?.toString().includes(searchTerm) ||
                          w.rider_id?.toString().includes(searchTerm);
    const matchesStatus = statusFilter === 'all' || w.admin_status?.toLowerCase() === statusFilter;
    return matchesSearch && matchesStatus;
  });
  
  const totalPages = Math.ceil(filteredWithdrawals.length / itemsPerPage);
  const paginatedWithdrawals = filteredWithdrawals.slice(
    (currentPage - 1) * itemsPerPage,
    currentPage * itemsPerPage
  );

  useEffect(() => {
    setCurrentPage(1);
  }, [searchTerm, statusFilter]);

  if (loading) {
    return (
      <div style={{ textAlign: 'center', padding: '60px', color: styles.textSecondary }}>
        <div style={{ width: '48px', height: '48px', border: `3px solid ${styles.border}`, borderTopColor: styles.purple, borderRadius: '50%', margin: '0 auto 16px auto', animation: 'spin 1s linear infinite' }} />
        <p>Loading withdrawals...</p>
      </div>
    );
  }

  const getStatusColor = (status) => {
    if (status === 'approved') return '#10B981';
    if (status === 'pending') return '#F59E0B';
    if (status === 'rejected') return '#EF4444';
    return '#3B82F6';
  };

  return (
    <div style={{ background: styles.cardBg, borderRadius: '32px', overflow: 'hidden', boxShadow: '0 25px 50px -12px rgba(0,0,0,0.25)', border: `1px solid ${styles.border}` }}>
      {/* Header */}
      <div style={{ 
        padding: '20px 24px', 
        borderBottom: `1px solid ${styles.border}`, 
        background: isDark ? '#1F2937' : 'linear-gradient(135deg, #F8FAFF 0%, #FFFFFF 100%)',
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        flexWrap: 'wrap',
        gap: '16px'
      }}>
        <div style={{ display: 'flex', gap: '12px', alignItems: 'center', flexWrap: 'wrap' }}>
          {/* Search */}
          <div style={{ 
            display: 'flex', 
            alignItems: 'center', 
            gap: '12px', 
            padding: '8px 16px', 
            border: `1px solid ${styles.border}`, 
            borderRadius: '40px', 
            backgroundColor: styles.inputBg 
          }}>
            <SearchIcon style={{ color: styles.textMuted, width: '14px', height: '14px' }} />
            <input
              type="text"
              placeholder="Search by name or ID..."
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
              style={{
                background: 'transparent',
                border: 'none',
                outline: 'none',
                fontSize: '13px',
                color: styles.textPrimary,
                width: '180px'
              }}
            />
          </div>
          
          {/* Status Filter */}
          <div style={{ 
            display: 'flex', 
            alignItems: 'center', 
            gap: '12px', 
            padding: '8px 16px', 
            border: `1px solid ${styles.border}`, 
            borderRadius: '40px', 
            backgroundColor: styles.inputBg 
          }}>
            <FilterIcon style={{ color: styles.textMuted, width: '14px', height: '14px' }} />
            <select
              value={statusFilter}
              onChange={(e) => setStatusFilter(e.target.value)}
              style={{
                background: 'transparent',
                border: 'none',
                outline: 'none',
                fontSize: '13px',
                color: styles.textPrimary,
                cursor: 'pointer'
              }}
            >
              <option value="all">All Status</option>
              <option value="approved">Approved</option>
              <option value="pending">Pending</option>
              <option value="rejected">Rejected</option>
              <option value="processing">Processing</option>
            </select>
          </div>
        </div>
        
        <button 
          onClick={() => {
            setSearchTerm('');
            setStatusFilter('all');
          }}
          style={{
            display: 'flex',
            alignItems: 'center',
            gap: '8px',
            padding: '8px 16px',
            borderRadius: '40px',
            border: `1px solid ${styles.border}`,
            background: 'transparent',
            color: styles.textSecondary,
            cursor: 'pointer',
            fontSize: '12px',
            transition: 'all 0.2s ease'
          }}
          onMouseEnter={(e) => e.currentTarget.style.background = styles.hoverBg}
          onMouseLeave={(e) => e.currentTarget.style.background = 'transparent'}
        >
          <RefreshIcon /> Clear Filters
        </button>
      </div>

      {/* Table */}
      {filteredWithdrawals.length === 0 ? (
        <div style={{ textAlign: 'center', padding: '80px 40px', color: styles.textMuted }}>
          <div style={{ width: '80px', height: '80px', background: styles.bgTertiary, borderRadius: '40px', display: 'flex', alignItems: 'center', justifyContent: 'center', margin: '0 auto 20px auto' }}>
            <WalletIcon style={{ width: '40px', height: '40px', opacity: 0.5 }} />
          </div>
          <p style={{ fontSize: '16px', fontWeight: '500', marginBottom: '8px', color: styles.textPrimary }}>No withdrawals found</p>
          <p style={{ fontSize: '13px' }}>No withdrawal requests match your search criteria</p>
        </div>
      ) : (
        <div style={{ overflowX: 'auto' }}>
          <table style={{ width: '100%', borderCollapse: 'collapse' }}>
            <thead>
              <tr style={{ background: styles.bgTertiary, borderBottom: `1px solid ${styles.border}` }}>
                <th style={{ padding: '14px 16px', textAlign: 'left', fontSize: '11px', fontWeight: '600', color: styles.textSecondary }}>ID</th>
                <th style={{ padding: '14px 16px', textAlign: 'left', fontSize: '11px', fontWeight: '600', color: styles.textSecondary }}>Name / ID</th>
                <th style={{ padding: '14px 16px', textAlign: 'left', fontSize: '11px', fontWeight: '600', color: styles.textSecondary }}>Amount</th>
                <th style={{ padding: '14px 16px', textAlign: 'left', fontSize: '11px', fontWeight: '600', color: styles.textSecondary }}>Status</th>
                <th style={{ padding: '14px 16px', textAlign: 'left', fontSize: '11px', fontWeight: '600', color: styles.textSecondary }}>Order IDs</th>
                <th style={{ padding: '14px 16px', textAlign: 'left', fontSize: '11px', fontWeight: '600', color: styles.textSecondary }}>Request Date</th>
                <th style={{ padding: '14px 16px', textAlign: 'center', fontSize: '11px', fontWeight: '600', color: styles.textSecondary }}>Actions</th>
              </tr>
            </thead>
            <tbody>
              {paginatedWithdrawals.map((row, idx) => {
                const displayName = row.restaurant_name || row.rider_name || 'Unknown';
                const entityId = row.resturant_id || row.rider_id || '';
                return (
                  <tr key={idx} style={{ borderBottom: `1px solid ${styles.borderLight}`, transition: 'background 0.2s ease' }}>
                    <td style={{ padding: '14px 16px', fontSize: '13px', fontWeight: '600', color: styles.textPrimary }}>
                      #{row.id}
                    </td>
                    <td style={{ padding: '14px 16px' }}>
                      <div>
                        <div style={{ fontSize: '13px', fontWeight: '600', color: styles.textPrimary }}>{displayName}</div>
                        {entityId && <div style={{ fontSize: '10px', color: styles.textMuted, marginTop: '2px' }}>ID: {entityId}</div>}
                      </div>
                    </td>
                    <td style={{ padding: '14px 16px' }}>
                      <span style={{ fontSize: '15px', fontWeight: '700', color: getStatusColor(row.admin_status) }}>
                        ₹{parseFloat(row.amount).toLocaleString()}
                      </span>
                    </td>
                    <td style={{ padding: '14px 16px' }}>
                      <StatusBadge status={row.admin_status} isDark={isDark} />
                    </td>
                    <td style={{ padding: '14px 16px', fontSize: '12px', color: styles.textSecondary }}>
                      {row.order_ids || '-'}
                    </td>
                    <td style={{ padding: '14px 16px', fontSize: '12px', color: styles.textSecondary }}>
                      {row.created_at ? new Date(row.created_at).toLocaleString() : '-'}
                    </td>
                    <td style={{ padding: '14px 16px' }}>
                      <ActionButtons row={row} onApprove={onApprove} onReject={onReject} onView={onView} isDark={isDark} />
                    </td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        </div>
      )}

      {/* Pagination */}
      {totalPages > 1 && (
        <div style={{ 
          padding: '14px 20px', 
          borderTop: `1px solid ${styles.border}`, 
          background: isDark ? '#1F2937' : '#F8FAFF',
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          flexWrap: 'wrap',
          gap: '12px'
        }}>
          <span style={{ fontSize: '12px', color: styles.textSecondary }}>
            Showing {((currentPage - 1) * itemsPerPage) + 1} to {Math.min(currentPage * itemsPerPage, filteredWithdrawals.length)} of {filteredWithdrawals.length} entries
          </span>
          <div style={{ display: 'flex', gap: '8px' }}>
            <button
              onClick={() => setCurrentPage(p => Math.max(1, p - 1))}
              disabled={currentPage === 1}
              style={{
                padding: '6px 12px',
                borderRadius: '40px',
                border: `1px solid ${styles.border}`,
                background: styles.cardBg,
                color: currentPage === 1 ? styles.textMuted : styles.textPrimary,
                cursor: currentPage === 1 ? 'not-allowed' : 'pointer',
                fontSize: '12px',
                transition: 'all 0.2s ease'
              }}
            >
              <ChevronLeftIcon /> Prev
            </button>
            <span style={{ padding: '6px 12px', fontSize: '12px', color: styles.textPrimary }}>
              Page {currentPage} of {totalPages}
            </span>
            <button
              onClick={() => setCurrentPage(p => Math.min(totalPages, p + 1))}
              disabled={currentPage === totalPages}
              style={{
                padding: '6px 12px',
                borderRadius: '40px',
                border: `1px solid ${styles.border}`,
                background: styles.cardBg,
                color: currentPage === totalPages ? styles.textMuted : styles.textPrimary,
                cursor: currentPage === totalPages ? 'not-allowed' : 'pointer',
                fontSize: '12px',
                transition: 'all 0.2s ease'
              }}
            >
              Next <ChevronRightIcon />
            </button>
          </div>
        </div>
      )}
    </div>
  );
};

// ===================== VIEW DETAILS MODAL =====================
const ViewDetailsModal = ({ withdrawal, onClose, isDark }) => {
  const styles = getThemeStyles(isDark);
  if (!withdrawal) return null;

  const displayName = withdrawal.restaurant_name || withdrawal.rider_name || 'Unknown';
  const entityId = withdrawal.resturant_id || withdrawal.rider_id || '';

  const getStatusColor = (status) => {
    if (status === 'approved') return '#10B981';
    if (status === 'pending') return '#F59E0B';
    if (status === 'rejected') return '#EF4444';
    return '#3B82F6';
  };

  return (
    <div style={{
      position: 'fixed',
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      background: 'rgba(0,0,0,0.7)',
      backdropFilter: 'blur(4px)',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      zIndex: 1000,
      padding: '20px'
    }}>
      <div style={{
        background: styles.cardBg,
        borderRadius: '24px',
        width: '100%',
        maxWidth: '480px',
        overflow: 'hidden',
        boxShadow: '0 25px 50px -12px rgba(0,0,0,0.25)',
        border: `1px solid ${styles.border}`
      }}>
        <div style={{
          padding: '20px 24px',
          borderBottom: `1px solid ${styles.border}`,
          background: isDark ? '#1F2937' : 'linear-gradient(135deg, #F8FAFF 0%, #FFFFFF 100%)',
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center'
        }}>
          <h3 style={{ fontSize: '18px', fontWeight: '700', color: styles.textPrimary, margin: 0 }}>Withdrawal Details</h3>
          <button 
            onClick={onClose} 
            style={{ 
              background: 'none', 
              border: 'none', 
              cursor: 'pointer', 
              color: styles.textMuted, 
              fontSize: '22px',
              transition: 'color 0.2s ease'
            }}
            onMouseEnter={(e) => e.currentTarget.style.color = styles.danger}
            onMouseLeave={(e) => e.currentTarget.style.color = styles.textMuted}
          >×</button>
        </div>
        
        <div style={{ padding: '24px' }}>
          <div style={{ marginBottom: '20px' }}>
            <label style={{ fontSize: '11px', color: styles.textMuted, display: 'block', marginBottom: '6px', fontWeight: '600' }}>Request ID</label>
            <p style={{ fontSize: '15px', fontWeight: '700', color: styles.textPrimary, margin: 0 }}>#{withdrawal.id}</p>
          </div>
          
          <div style={{ marginBottom: '20px' }}>
            <label style={{ fontSize: '11px', color: styles.textMuted, display: 'block', marginBottom: '6px', fontWeight: '600' }}>Name</label>
            <p style={{ fontSize: '15px', fontWeight: '600', color: styles.textPrimary, margin: 0 }}>{displayName}</p>
            {entityId && <p style={{ fontSize: '12px', color: styles.textSecondary, margin: '4px 0 0' }}>Entity ID: {entityId}</p>}
          </div>
          
          <div style={{ marginBottom: '20px' }}>
            <label style={{ fontSize: '11px', color: styles.textMuted, display: 'block', marginBottom: '6px', fontWeight: '600' }}>Amount</label>
            <p style={{ fontSize: '26px', fontWeight: '700', color: getStatusColor(withdrawal.admin_status), margin: 0 }}>₹{parseFloat(withdrawal.amount).toLocaleString()}</p>
          </div>
          
          <div style={{ marginBottom: '20px' }}>
            <label style={{ fontSize: '11px', color: styles.textMuted, display: 'block', marginBottom: '6px', fontWeight: '600' }}>Status</label>
            <StatusBadge status={withdrawal.admin_status} isDark={isDark} />
          </div>
          
          <div style={{ marginBottom: '20px' }}>
            <label style={{ fontSize: '11px', color: styles.textMuted, display: 'block', marginBottom: '6px', fontWeight: '600' }}>Order IDs</label>
            <p style={{ fontSize: '13px', color: styles.textSecondary, margin: 0 }}>{withdrawal.order_ids || '-'}</p>
          </div>
          
          <div style={{ marginBottom: '20px' }}>
            <label style={{ fontSize: '11px', color: styles.textMuted, display: 'block', marginBottom: '6px', fontWeight: '600' }}>Request Date</label>
            <p style={{ fontSize: '13px', color: styles.textSecondary, margin: 0 }}>
              {withdrawal.created_at ? new Date(withdrawal.created_at).toLocaleString() : '-'}
            </p>
          </div>
          
          {withdrawal.updated_at && withdrawal.updated_at !== withdrawal.created_at && (
            <div style={{ marginBottom: '20px' }}>
              <label style={{ fontSize: '11px', color: styles.textMuted, display: 'block', marginBottom: '6px', fontWeight: '600' }}>Last Updated</label>
              <p style={{ fontSize: '13px', color: styles.textSecondary, margin: 0 }}>
                {new Date(withdrawal.updated_at).toLocaleString()}
              </p>
            </div>
          )}
        </div>
        
        <div style={{
          padding: '16px 24px',
          borderTop: `1px solid ${styles.border}`,
          display: 'flex',
          justifyContent: 'flex-end'
        }}>
          <button 
            onClick={onClose} 
            style={{
              padding: '8px 20px',
              borderRadius: '40px',
              border: 'none',
              background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
              color: 'white',
              cursor: 'pointer',
              fontSize: '13px',
              fontWeight: '500',
              transition: 'transform 0.2s ease'
            }}
            onMouseEnter={(e) => e.currentTarget.style.transform = 'translateY(-1px)'}
            onMouseLeave={(e) => e.currentTarget.style.transform = 'translateY(0)'}
          >Close</button>
        </div>
      </div>
    </div>
  );
};

// ===================== MAIN COMPONENT =====================
const Withdrawals = ({ isDark = false }) => {
  const navigate = useNavigate();
  const styles = getThemeStyles(isDark);
  const [activeTab, setActiveTab] = useState('restaurant'); // 'restaurant' or 'rider'
  const [restaurantWithdrawals, setRestaurantWithdrawals] = useState([]);
  const [riderWithdrawals, setRiderWithdrawals] = useState([]);
  const [loadingRestaurant, setLoadingRestaurant] = useState(true);
  const [loadingRider, setLoadingRider] = useState(true);
  const [selectedWithdrawal, setSelectedWithdrawal] = useState(null);
  const [showModal, setShowModal] = useState(false);

  const fetchRestaurantWithdrawals = async () => {
    setLoadingRestaurant(true);
    try {
      const response = await getData("Payments/restaurantwithdrawals");
      console.log("Restaurant Withdrawals:", response);
      if (response && response.status === true && response.data) {
        setRestaurantWithdrawals(response.data);
      }
    } catch (error) {
      console.error("Error fetching restaurant withdrawals:", error);
    } finally {
      setLoadingRestaurant(false);
    }
  };

  const fetchRiderWithdrawals = async () => {
    setLoadingRider(true);
    try {
      const response = await getData("Payments/riderwithdrawals");
      console.log("Rider Withdrawals:", response);
      if (response && response.status === true && response.data) {
        setRiderWithdrawals(response.data);
      }
    } catch (error) {
      console.error("Error fetching rider withdrawals:", error);
    } finally {
      setLoadingRider(false);
    }
  };

  useEffect(() => {
    fetchRestaurantWithdrawals();
    fetchRiderWithdrawals();
  }, []);

  const handleApprove = async (withdrawal, type) => {
    if (!window.confirm(`Approve withdrawal #${withdrawal.id} for ₹${parseFloat(withdrawal.amount).toLocaleString()}?`)) return;
    
    try {
      const endpoint = type === 'restaurant' 
        ? 'Payments/approve_restaurant_withdrawal' 
        : 'Payments/approve_rider_withdrawal';
      
      const response = await postData(endpoint, { id: withdrawal.id });
      
      if (response && response.status === true) {
        alert('Withdrawal approved successfully!');
        fetchRestaurantWithdrawals();
        fetchRiderWithdrawals();
      } else {
        alert(response?.message || 'Failed to approve withdrawal');
      }
    } catch (error) {
      console.error('Error approving withdrawal:', error);
      alert('Network error. Please try again.');
    }
  };

  const handleReject = async (withdrawal, type) => {
    const remarks = prompt('Enter reason for rejection:', '');
    if (remarks === null) return;
    
    try {
      const endpoint = type === 'restaurant' 
        ? 'Payments/reject_restaurant_withdrawal' 
        : 'Payments/reject_rider_withdrawal';
      
      const response = await postData(endpoint, { id: withdrawal.id, remarks });
      
      if (response && response.status === true) {
        alert('Withdrawal rejected!');
        fetchRestaurantWithdrawals();
        fetchRiderWithdrawals();
      } else {
        alert(response?.message || 'Failed to reject withdrawal');
      }
    } catch (error) {
      console.error('Error rejecting withdrawal:', error);
      alert('Network error. Please try again.');
    }
  };

  const handleView = (withdrawal) => {
    setSelectedWithdrawal(withdrawal);
    setShowModal(true);
  };

  const handleBack = () => navigate(-1);

  // Calculate stats
  const restaurantStats = {
    total: restaurantWithdrawals.length,
    totalAmount: restaurantWithdrawals.reduce((sum, w) => sum + parseFloat(w.amount), 0),
    pending: restaurantWithdrawals.filter(w => w.admin_status === 'pending').length,
    approved: restaurantWithdrawals.filter(w => w.admin_status === 'approved').length,
    rejected: restaurantWithdrawals.filter(w => w.admin_status === 'rejected').length
  };

  const riderStats = {
    total: riderWithdrawals.length,
    totalAmount: riderWithdrawals.reduce((sum, w) => sum + parseFloat(w.amount), 0),
    pending: riderWithdrawals.filter(w => w.admin_status === 'pending').length,
    approved: riderWithdrawals.filter(w => w.admin_status === 'approved').length,
    rejected: riderWithdrawals.filter(w => w.admin_status === 'rejected').length
  };

  const currentStats = activeTab === 'restaurant' ? restaurantStats : riderStats;
  const currentWithdrawals = activeTab === 'restaurant' ? restaurantWithdrawals : riderWithdrawals;
  const currentLoading = activeTab === 'restaurant' ? loadingRestaurant : loadingRider;

  return (
    <div style={{ minHeight: '100vh', backgroundColor: styles.bgPrimary, fontFamily: "'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif", transition: 'all 0.3s ease' }}>
      <div style={{ position: 'relative', zIndex: 1, padding: '32px 24px' }}>
        {/* Header */}
        <div style={{ maxWidth: '1200px', margin: '0 auto 32px auto' }}>
          <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', flexWrap: 'wrap', gap: '16px' }}>
            <button 
              onClick={handleBack} 
              style={{ 
                display: 'flex', 
                alignItems: 'center', 
                gap: '8px', 
                padding: '10px 20px',
                background: styles.bgTertiary,
                border: `1px solid ${styles.border}`,
                borderRadius: '40px',
                color: styles.textPrimary,
                cursor: 'pointer',
                fontSize: '14px',
                fontWeight: '500',
                transition: 'all 0.3s ease'
              }}
              onMouseEnter={(e) => e.currentTarget.style.background = styles.hoverBg}
              onMouseLeave={(e) => e.currentTarget.style.background = styles.bgTertiary}
            >
              <BackIcon /> Back to Dashboard
            </button>
            
            <div style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
              <div style={{ display: 'flex', alignItems: 'center', gap: '12px', background: styles.bgTertiary, padding: '8px 20px', borderRadius: '40px', border: `1px solid ${styles.border}` }}>
                <SparklesIcon />
                <span style={{ color: styles.textPrimary, fontSize: '14px', fontWeight: '500' }}>Withdrawals Management</span>
              </div>
            </div>
          </div>
        </div>

        {/* Main Content */}
        <div style={{ maxWidth: '1200px', margin: '0 auto' }}>
          {/* Switch Toggle Button */}
          <div style={{ 
            display: 'flex', 
            justifyContent: 'center', 
            marginBottom: '32px'
          }}>
            <div style={{
              background: styles.bgTertiary,
              borderRadius: '60px',
              padding: '6px',
              display: 'inline-flex',
              gap: '8px',
              border: `1px solid ${styles.border}`
            }}>
              <button
                onClick={() => setActiveTab('restaurant')}
                style={{
                  display: 'flex',
                  alignItems: 'center',
                  gap: '10px',
                  padding: '12px 32px',
                  borderRadius: '50px',
                  border: 'none',
                  fontSize: '14px',
                  fontWeight: '600',
                  cursor: 'pointer',
                  transition: 'all 0.3s ease',
                  background: activeTab === 'restaurant' ? 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)' : 'transparent',
                  color: activeTab === 'restaurant' ? '#FFFFFF' : styles.textSecondary
                }}
              >
                <RestaurantIcon style={{ width: '18px', height: '18px' }} />
                Restaurant Withdrawals
                {activeTab === 'restaurant' && (
                  <span style={{
                    background: 'rgba(255,255,255,0.2)',
                    padding: '2px 8px',
                    borderRadius: '20px',
                    fontSize: '11px',
                    marginLeft: '6px'
                  }}>
                    {restaurantStats.total}
                  </span>
                )}
              </button>
              <button
                onClick={() => setActiveTab('rider')}
                style={{
                  display: 'flex',
                  alignItems: 'center',
                  gap: '10px',
                  padding: '12px 32px',
                  borderRadius: '50px',
                  border: 'none',
                  fontSize: '14px',
                  fontWeight: '600',
                  cursor: 'pointer',
                  transition: 'all 0.3s ease',
                  background: activeTab === 'rider' ? 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)' : 'transparent',
                  color: activeTab === 'rider' ? '#FFFFFF' : styles.textSecondary
                }}
              >
                <RiderIcon style={{ width: '18px', height: '18px' }} />
                Rider Withdrawals
                {activeTab === 'rider' && (
                  <span style={{
                    background: 'rgba(255,255,255,0.2)',
                    padding: '2px 8px',
                    borderRadius: '20px',
                    fontSize: '11px',
                    marginLeft: '6px'
                  }}>
                    {riderStats.total}
                  </span>
                )}
              </button>
            </div>
          </div>

          {/* Stats Cards - 4 cards */}
          <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(200px, 1fr))', gap: '16px', marginBottom: '32px' }}>
            <StatCard 
              icon={<WalletIcon />}
              title="Total Withdrawals"
              value={currentStats.total}
              color="#3B82F6"
              isDark={isDark}
            />
            <StatCard 
              icon={<TrendingIcon />}
              title="Total Amount"
              value={`₹${currentStats.totalAmount.toLocaleString()}`}
              color="#10B981"
              isDark={isDark}
            />
            <StatCard 
              icon={<CheckIcon />}
              title="Approved"
              value={currentStats.approved}
              color="#10B981"
              subtitle="✓"
              isDark={isDark}
            />
            <StatCard 
              icon={<XIcon />}
              title="Pending"
              value={currentStats.pending}
              color="#F59E0B"
              subtitle="⏳"
              isDark={isDark}
            />
          </div>

          {/* Withdrawals Table */}
          <WithdrawalsTable
            withdrawals={currentWithdrawals}
            loading={currentLoading}
            onApprove={(row) => handleApprove(row, activeTab)}
            onReject={(row) => handleReject(row, activeTab)}
            onView={handleView}
            isDark={isDark}
          />
        </div>
      </div>

      {/* View Details Modal */}
      {showModal && (
        <ViewDetailsModal
          withdrawal={selectedWithdrawal}
          onClose={() => {
            setShowModal(false);
            setSelectedWithdrawal(null);
          }}
          isDark={isDark}
        />
      )}

      <style>{`
        @keyframes spin {
          to { transform: rotate(360deg); }
        }
      `}</style>
    </div>
  );
};

export default Withdrawals;